module.exports = __webpack_public_path__ + "ringtone.272e92fd.mp3";